import { render, staticRenderFns } from "./apiDoc.vue?vue&type=template&id=c8d7f896&scoped=true&"
import script from "./apiDoc.vue?vue&type=script&lang=js&"
export * from "./apiDoc.vue?vue&type=script&lang=js&"
import style0 from "./apiDoc.vue?vue&type=style&index=0&id=c8d7f896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d7f896",
  null
  
)

export default component.exports